import { FcGoogle } from 'react-icons/fc';
import Typography from '../../components/Typography';
import CardLayout from '../../layouts/CardLayout';
import Button from '../../components/Button';
import Link from '../../components/Link';
import styles from './Login.module.scss';
import { Navigate } from 'react-router-dom';
import { useUserSession } from '../../components/UserSession';

const REDIRECT = '/reviews';

function Login() {
  const { user } = useUserSession();

  if (user) {
    return <Navigate to={REDIRECT} replace />;
  }

  return (
    <CardLayout>
      <div className={styles.container}>
        <Typography textType="h2" as="h1" textWeight="normal">
          Welcome
        </Typography>
        <Typography textType="h4" as="p" textWeight="normal" textColor="text-2">
          Sign in to view dashboard
        </Typography>
        <div className={styles.action}>
          <Button
            icon={{ placement: 'left', element: FcGoogle }}
            className={styles.button}
            variant="outline"
            onClick={async () => {
              const searchParams = new URLSearchParams({
                redirect: new URL(
                  '/callback',
                  window.location.origin,
                ).toString(),
                state: REDIRECT,
              });
              window.location.replace(
                `${process.env.REACT_APP_API_URL}/auth/google?${searchParams}`,
              );
            }}
          >
            Sign in with Google
          </Button>
          <Button
            className={styles.button}
            variant="ghost"
            type="link"
            as={Link}
            to="/"
            pure
          >
            Back to Home
          </Button>
        </div>
        {/*<Typography textType='p1' as='p'>
          Don't have an account? <Link type='link' to='/signup'>
            Sign up
          </Link>.
        </Typography>*/}
      </div>
    </CardLayout>
  );
}

Login.routeProps = {
  exact: true,
  path: '/login',
};
export default Login;
